/**
 * Globale Konfiguration fuer die Scanner PWA.
 * Alle konfigurierbaren Werte werden hier zentralisiert.
 */
export const config = {
  /** API-Basis-URL. Defaults auf localhost fuer lokale Entwicklung. */
  apiUrl: import.meta.env['VITE_API_URL'] ?? 'https://api.fanini.live/api',
  /** Clerk Publishable Key fuer Auth. */
  clerkPublishableKey: import.meta.env['VITE_CLERK_PUBLISHABLE_KEY'] ?? '',
  /** App-Titel. */
  appTitle: 'Fanini Scanner',
} as const;
